import {signal} from "@preact/signals-react"
export const teacher = signal({})

